import 'intersection-observer';
import stickybits from 'stickybits';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import { DeviceDetector } from './utils/helper/browserDetection';

if (DeviceDetector.isIOs()) {
    window.createImageBitmap = undefined as any;
}

// TODO: Or use onAllTriggersLoaded of scrollyTeller
window.onbeforeunload = () => {
    window.scrollTo(0, 0);
};
window.onload = () => {
    if (DeviceDetector.isInternetExplorer) {
        stickybits('.sticky-standard', {
            stickyBitStickyOffset: 100,
            parentClass: 'sticky-parent-sub'
        });
        stickybits('.sticky-prominent', {
            stickyBitStickyOffset: 60,
            parentClass: 'sticky-parent-sub'
        });
        stickybits('.sticky-full', {
            stickyBitStickyOffset: 60,
            parentClass: 'sticky-parent'
        });
    }
};

ReactDOM.render(<App />, document.querySelector('main'));
